import React, { lazy } from "react";

const LazyReporting = lazy(() => import("./Reporting"));

const Reporting = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyReporting {...props} />;

export default Reporting;
